export const monthsFullName = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
export const monthsAbbreviated = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
export const teste = ""
export const MENSAGEM_OBSERVACAO_EXPIRADO = "Recusado por expiração"
export const MENSAGEM_OBSERVACAO_CANCELADO = "Recusado por reprovação do financiamento"
export const MENSAGEM_QUANTIDADE_CABOS_INVALIDA = "A quantidade deve ser múltipla de 25"